import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {MUTATION_KEYS, QUERY_KEYS, queryClient} from '@/queryClient'
import {AxiosError, AxiosResponse} from 'axios'
import {httpMarkNotification, MarkNotificationPayload} from '../http/notifications.http'
import {FormErrorResponse} from '@/types'
import {errorHandler} from '@/utilities/helpers'

export const useMarkNotification = ({
    urlParams,
    options
}: {
    urlParams: {notificationId: string}
    options?: UseMutationOptions<
        AxiosResponse<unknown>,
        AxiosError<{errors: FormErrorResponse[]}>,
        MarkNotificationPayload
    >
}) =>
    useMutation({
        ...options,
        mutationKey: [MUTATION_KEYS.MARK_NOTIFICATION],
        mutationFn: payload => {
            return httpMarkNotification(urlParams.notificationId, payload)
        },
        onSuccess: () => {
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.NOTIFICATIONS]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.NOTIFICATION_COUNT]})
        },
        onError: errorHandler
    })
